import React from 'react';
import { css } from 'aphrodite';
import styles from './error-message-styles';

const ErrorMessageView = (props) => (
  <div className={css(styles.root, props.showError && styles.visibleRoot)}>
    <div className={css(styles.errorContent)} onClick={props.clearError}>
      <div className={css(styles.errorEmoji)}>!</div>
      <div className={css(styles.errorMessageText)}>{props.errorMessage}</div>
    </div>
  </div>
);

export default ErrorMessageView;



// WEBPACK FOOTER //
// ./src/components/snackbars/error-message-view.js